export default function LoadingIndicator({label = 'Loading'}) {
  return <s-stack direction="inline" justifyContent="center" alignItems="center" padding="large-400">
    <s-spinner size="large-100" accessibilityLabel={label} />
  </s-stack>;
}
